interface IImage {
  src: string
  width?: string | number | undefined
  height?: string | number | undefined
  className?: string
}
const Image = ({ src, width, height, ...rest }: IImage) => {
  return (
    <img
      src={src}
      width={width}
      height={height}
      loading='lazy'
      decoding='async'
      {...rest}
    />
  )
}

export default Image
